import { SearchObject } from "app/common/Model/SearchObject";
import { exportExcelPatientRegisterServiceReport, pagingPatientServiceRegisterReport } from "app/services/PatientServiceRegisterService";
import { reportVoucherExpense } from "app/services/ReportService";
import { makeAutoObservable } from "mobx";
import { toast } from "react-toastify";
import { saveAs } from "file-saver";
import { VOUCHER_TYPE_VALUE } from "app/common/LocalConst";

export default class UncompletedServicesReportStore {
  pageUncompleteServicesReport = null;

  intactSearchObject = {
    ...new SearchObject(),
    fromDate: new Date(),
    toDate: new Date(),
    departmentId: null,
    staffId: null,
    unCompleted: true,
    getAllServiceInTreatment: true,
  }

  searchObject = JSON.parse(JSON.stringify(this.intactSearchObject))

  constructor() {
    makeAutoObservable(this);
  }

  handleChangeFormSearch = (values) => {
    this.searchObject = {
      ...this.searchObject,
      ...values,
    };
    this.pagingUncompletedRegisterServicesReport();
  }

  pagingUncompletedRegisterServicesReport = async () => {
    let { department, healthCareSvId, groupId, patientId, ...ortherData } = this.searchObject;
    if (department) {
      ortherData.departmentId = department.id;
    }
    if (healthCareSvId) {
      ortherData.healthCareSvId = healthCareSvId.id;
    }
    if (groupId) {
      ortherData.groupId = groupId.id;
    }
    if (patientId) {
      ortherData.patientId = patientId?.id;
    }
    try {
      const payload = {
        ...ortherData,
        unCompleted: true,
        getAllServiceInTreatment: true,
      };

      const { data } = await pagingPatientServiceRegisterReport(payload);
      this.pageUncompleteServicesReport = data;
    }
    catch (error) {
      console.error(error);
      toast.error("Có lỗi xảy ra khi lấy dữ liệu");
    }
  };

  openConfirmExport = false;

  handleOpenConfirmExport = () => {
    this.openConfirmExport = true;
  }

  handleClose = () => {
    this.openConfirmExport = false;
  }

  handleExportExcelUncompletedServiceReport = async () => {
    toast.info("Yêu cầu đang được xử lý", {
      autoClose: 6666
    });

    try {
      const payload = {
        ...this.searchObject,
        unCompleted: true,
        getAllServiceInTreatment: true,
      };

      const response = await exportExcelPatientRegisterServiceReport(payload);

      if (response.status === 200) {
        let blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        saveAs(blob, "BAO_CAO_DICH_VU_CHUA_THUC_HIEN.xlsx");

        // const url = window.URL.createObjectURL(new Blob([response.data]));
        // const link = document.createElement("a");
        // link.href = url;
        // link.setAttribute("download", "BAO_CAO_DICH_VU_CHUA_THUC_HIEN.xlsx");
        // document.body.appendChild(link);
        // link.click();
        // link.parentNode.removeChild(link);

        toast.success("Xuất danh sách thành công");

      }
      else {
        throw Error();
      }
    } catch (error) {
      toast.error("Có lỗi xảy ra, vui lòng thử lại sau");
      console.error("Error export excel report:", error);
    }
  };

  resetStore = () => {
    this.pageUncompleteServicesReport = null;
    this.searchObject = JSON.parse(JSON.stringify(this.intactSearchObject));

  }
}